import * as React from "react";

import { AppCard } from "@/components/ui/AppCard";
import { cn } from "@/lib/utils";

export type TSectionCardProps = {
  /** Left side of header: category name, logo+title, or avatar+name+company */
  headerLeft: React.ReactNode;
  /** Right side of header: score badge or Connect button */
  headerRight?: React.ReactNode;
  /** Main content: feedback text, description, summary */
  children: React.ReactNode;
  /** Optional action row: Request intro / Shortlist / Dismiss, or Connect */
  actions?: React.ReactNode;
  /** Footer: shared chat input. Omit to hide. */
  footer?: React.ReactNode;
  className?: string;
};

const SECTION_CARD_PADDING = "p-4";
const SECTION_CARD_GAP = "space-y-4";

/**
 * Shared base card for todo, deal stack, deal network, and request-intro items.
 * Ensures same base component and spacing across all section card types.
 */
export function SectionCard({ headerLeft, headerRight, children, actions, footer, className }: TSectionCardProps) {
  return (
    <AppCard className={cn(SECTION_CARD_PADDING, SECTION_CARD_GAP, className)}>
      {/* Header */}
      <div className="flex min-w-0 items-start justify-between gap-4">
        <div className="min-w-0 flex-1">{headerLeft}</div>
        {headerRight != null ? <div className="flex-shrink-0">{headerRight}</div> : null}
      </div>

      {/* Body */}
      <div className="min-w-0">{children}</div>

      {/* Optional actions */}
      {actions != null && actions !== false ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}

      {/* Footer: Ask question input */}
      {footer != null ? <div className="mt-0">{footer}</div> : null}
    </AppCard>
  );
}
